import { isEmpty } from 'lodash-es';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

import { FBCLID } from '@pflegia/types/common/constants/analytics';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

import { INITIAL_PREFIX, UTM_KEYS, INITIAL_UTM_TIMESTAMP, LATEST_UTM_TIMESTAMP } from '../constants/utm-keys';

const cookieOptions = { sameSite: 'Strict', secure: true } as const;
const KEYS = [...UTM_KEYS, FBCLID];

/**
 * Saves UTM values from query into cookies.
 * @param withInitial - Whether to save initial UTM values into cookies.
 * If false, it will only save latest UTM values.
 */
export const useUtmToCookie = (withInitial = true) => {
  const { query } = useRouter();
  const hasUtm = useMemo(() => withInitial && KEYS.some(key => cookieStorage.getItem(INITIAL_PREFIX + key)), [withInitial]);

  useEffect(() => {
    if (isEmpty(query)) return;
    if (withInitial) {
      if (!hasUtm) cookieStorage.setItem(INITIAL_UTM_TIMESTAMP, String(Date.now()), cookieOptions);
      cookieStorage.setItem(LATEST_UTM_TIMESTAMP, String(Date.now()), cookieOptions);
    }
    KEYS.forEach(utmKey => {
      const cookieKey = (withInitial && !hasUtm ? INITIAL_PREFIX : '') + utmKey;
      const value = query[utmKey];
      if (!value) return;
      cookieStorage.setItem(utmKey, String(value), cookieOptions);
      const savedValue = cookieStorage.getItem(cookieKey);
      if (!withInitial && savedValue === value) return;
      cookieStorage.setItem(cookieKey, String(value), cookieOptions);
    });
  }, [query, hasUtm, withInitial]);
};
